module.exports = __webpack_public_path__ + "img/logowout.4b94cb00.png";